import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js"

/*
Exemplo de uso:
  <input data-controller='mask'
         data-mask-format-value='cpf'>
*/

export default class extends Controller {
  static values = { format: String }

  connect() {
    switch(this.formatValue) {
      case 'time':
        this.maskTime()
        break;

      case 'cellphone':
        this.maskCellPhone()
        break;

      case 'date':
        this.maskDate()
        break;

      case 'cpf':
        this.maskCpf()
        break;

      case 'titulo':
        this.maskTitulo()
        break;

      case 'secao':
        this.maskSecao()
        break;

      default:
        console.log('mask_controller - invalid format')
    }
  }

  maskTime() {
    new Cleave(this.element, {
      time: true,
      timePattern: ['h', 'm']
    })
  }

  maskCellPhone() {
    new Cleave(this.element, {
      blocks: [0, 2, 5, 4],
      delimiters: ['(', ') ', '-']
    })
  }

  maskDate() {
    new Cleave(this.element, {
      date: true,
      datePattern: ['d', 'm', 'Y']
    })
  }

  maskCpf() {
    new Cleave(this.element, {
      blocks: [3, 3, 3, 2],
      delimiters: ['.', '.', '-'],
      numericOnly: true
    })
  }

  maskTitulo() {
    new Cleave(this.element, {
      blocks: [12],
      numericOnly: true
    })
  }

  maskSecao() {
    new Cleave(this.element, {
      blocks: [4],
      numericOnly: true
    })
  }
}
